import React, { Component } from "react";
import { connect } from "react-redux";
import Typography from "material-ui/Typography";
import Profiles from "../data/Profiles.json";
import { Link } from "react-router-dom";
import Button from "material-ui/Button";
import getProfile from "../utils/getProfile";

class ProfileView extends Component {
  state = {};

  constructor(props) {
    super(props);

    // let iIndex = parseInt(props.quiz.questions.length, 10);
    // //Check if they did the test
    // if (props.quiz.questions[iIndex - 3].givenAnswers.length === 0) {
    //   history.push(`/quiz/1`);
    // }

    this.state = {
      profile: getProfile(props.quiz.questions)
    };
  }

  breakLine(text) {
    var br = React.createElement("br");
    var regex = /(<br \/>)/g;
    return text.split(regex).map(function(line, index) {
      return line.match(regex) ? <br key={"key_" + index} /> : line;
    });
  }

  render() {
    let profile_letters="";
    let sProfileText_state = "";
    /*let sProfileText_goals = [];*/
    let listItems = "";
    let list="";/*images names*/
    let sProfileText_text_title_1 = "";
    let sProfileText_text_title_2 = "";
    let goal_numbers="";/*number of goals*/
    const links = ["","poverty/", "hunger/", "health/", "education/", "gender-equality/","water-and-sanitation/","energy/","economic-growth/",
    "infrastructure-industrialization/","inequality/","cities/","sustainable-consumption-production/","climate-change-2/","oceans/","biodiversity/",
    "peace-justice/","globalpartnerships/"];/*declare the array of links for each goal*/
    /*const goals_style_li={
        display: "inline-block",
        verticalAlign: "top"
    }*/
    //Read the profiles from data/Profiles.json
    profile_letters=this.state.profile;
    sProfileText_text_title_1 = this.breakLine(
      Profiles.profiles[this.state.profile].text_title_1
    );
    sProfileText_text_title_2 = this.breakLine(
      Profiles.profiles[this.state.profile].text_title_2
    );
    if (!Profiles.profiles[this.state.profile]) {
      sProfileText_state =
        "The following profile doens't exist yet: " + this.state.profile;
    } else {
      /*
      sProfileText_state = this.breakLine(Profiles.profiles[this.state.profile]);
      */
      sProfileText_state = this.breakLine(
        Profiles.profiles[this.state.profile].state
      );

        list = Profiles.profiles[this.state.profile].goals.map((element,index) => (
          /*"img_" + */
          element.split(" ")[0]+".jpg"
        ));
        goal_numbers = Profiles.profiles[this.state.profile].goals.map((element,index) => (
          /*"img_" + */
          element.split(" ")[0]
        ));

      listItems = Profiles.profiles[this.state.profile].goals.map((element,index) => (

        <div key ={"goals_"+index}>

          <div>
          <a href={"https://www.un.org/sustainabledevelopment/"+links[goal_numbers[index]]} target="_">
            <img src={require("../assets/"+list[index])} width="120" padding="10" alt="goal"/>
          </a>
          </div>
          {element}
        </div>
      ));
    }
    const color1 = { color: "#bf0d3e" };
    const color2 = { color: "#897222" };
    const color3 = { color: "#8146af" };
    const color4 = { color: "#eaaa02" };
    const color5 = { color: "#64a70a" };

    const title_purple = {
      color: "#8146af",
      fontWeight: "bold",
      fontSize: "1.5em",
      marginTop: "30px"
    };
    const title_darkblue = {
      color: "#0b2440",
      fontWeight: "bold",
      fontSize: "0.8em"
    };
    const subtitle_darkblue = {
      color: "#0b2440",
      fontWeight: "bold",
      fontSize: "0.7em"
    };
    const goals_style_ul = {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
      gridGap: "10px",
      gridAutoRows: "160px"
    };

    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-12">

                <Typography
                  component="div"
                  style={{
                    margin: "20px",
                    textAlign: "left",
                    fontWeight: "lighter"
                  }}
                >
                <span style={title_purple}>
                  The Global Goals for<br />
                  <span>{sProfileText_text_title_1}</span>
                  <span style={title_darkblue}>{sProfileText_text_title_2}</span>
                  <br />
                </span>
                <div className="goal-img-link">
                  <div style={goals_style_ul}>{listItems}</div>
                </div>
              </Typography>
              <Link to={"/quiz-finished"}>
                <Button
                  variant="raised"
                  style={{ marginBottom: "20px" }}
                  color="primary"
                >
                  Next
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps({ quiz }, { match: { params } }) {
  return {
    quiz
  };
}

export default connect(mapStateToProps)(ProfileView);



// WEBPACK FOOTER //
// ./src/views/GoalsView.jsx